/** @jsxImportSource @emotion/react */
import { loadPageQuery, createPageQuery, usePageQuery } from '../page-query.ts'
import { createFileRoute } from '@tanstack/react-router'
import { AccountWaitingPage } from '../pages/account-waiting.tsx'
import { loadWaitingPage } from '#start/server/account-collections'
import { documentHead } from '../components/document-head.ts'
const pageQuery = createPageQuery('loadWaitingPage', loadWaitingPage, {
	staleTime: 10_000,
})

export const Route = createFileRoute('/_app/@{$orgSlug}_/-/waiting')({
	staticData: {
		workspaceSwitch: { section: 'waiting' },
		navigation: { rail: 'workspace', item: 'waiting' },
		orgScope: { section: 'waiting' },
	},
	context: ({ params }) => ({ pageQueryInput: { orgSlug: params.orgSlug } }),
	loader: ({ context, preload }) =>
		loadPageQuery(
			context.queryClient,
			pageQuery(context.actorKey, context.pageQueryInput),
			preload,
		),
	head: ({ loaderData }) => documentHead(loaderData?.head),
	component: Page,
})
function Page() {
	const { payload } = usePageData()
	const { pageLocation: location } = Route.useRouteContext()
	return <AccountWaitingPage payload={payload} currentHref={location.href} />
}

function usePageData() {
	const { actorKey, pageQueryInput } = Route.useRouteContext()
	return usePageQuery(pageQuery(actorKey, pageQueryInput)).data
}
